<div class="modal-header">
  <h4 class="modal-title">Edit Consult Note Specialty</h4>
</div>
<div class="modal-body">
  <div>Update the medical specialty of this consult note:</div>
  <ng-select
    placeholder="Choose a specialty"
    class="mb-3 mt-1"
    [items]="referralSpecialties"
    bindValue="name"
    bindLabel="name"
    [(ngModel)]="patientAttachment.selectedSpecialty"
    />
  <app-additional-details-input
    id="selectedSpecialtyAdditionalDetails"
    [(value)]="patientAttachment.selectedSpecialtyAdditionalDetails"
    />
  <div class="mt-3 p-2 rounded text-bg-light">
    <div>Providers with a verification related to this consult note:</div>
    @if (!loadingProviders) {
      <div class="d-flex flex-row flex-wrap">
        @for (provider of uniqueProviders; track provider) {
          <div class="m-2">
            <app-prescriber-name [provider]="provider" [showSpecialtiesDetails]="true" />
          </div>
        }
      </div>
    } @else {
      <mat-spinner diameter="30" />
    }
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="onCancelClick()">Cancel</button>
  <button type="button" class="btn btn-primary" (click)="onSaveClick($event)">Save</button>
</div>
